import { styled } from '@mui/material/styles';
import { palette } from '@/theme/palette';

/**
 * StepperIcon with styling matching AXP design
 */
const StepperCircleIcon = styled('div')(
  ({ color, borderColor }: { color: string; borderColor: string }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '40px',
    width: '40px',
    fontSize: '16px',
    fontWeight: 'bold',
    borderRadius: '50%',
    outline: `2px solid ${borderColor}`,
    '&.outlined': {
      color: color,
      backgroundColor: 'transparent',
    },
    '&.contained': {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      color: palette?.white?.main,
      backgroundColor: color,
    },
  }),
);

export default StepperCircleIcon;
